import { Database } from '../components/main/EditDatabase/EditDatabase'

export const APP_ID = 'spreadsheets'
export const APP_NAME = 'SHEETS'
export const APP_SUBTITLE = 'Report'
export const APP_FULL_NAME = `${APP_NAME} ${APP_SUBTITLE}`

export const FILE_PREVIEW = 'FILE_PREVIEW'
export const FILE_PREVIEW_ERROR = 'FILE_PREVIEW_ERROR'

export const FILE_UPLOAD = 'FILE_UPLOAD'
export const SELECT_SHEET = 'SELECT_SHEET'

export const BASE_SERVICE_URL = '/services/live-spreadsheets/spreadsheets'
// export const BASE_SERVICE_URL = "/services/live-spreadsheets2/spreadsheets2"
export const STATUS_CACHE_PREVIEW = {
    PROCESSING: 'processing',
    OK: 'ok',
    ERROR: 'error'
}

export const BASE_CREDENTIALS = {
    credentials: 'same-origin',
    cache: 'no-cache'
}
export const HEADER_JSON = {
    'Content-Type': 'application/json',
    'X-Forwarded-Proto': 'https'
}

export const HEADER_FORM = {
    'Content-Type': 'multipart/form-data',
    'X-Forwarded-Proto': 'https'
}
export const SETTINGS = {
    ...BASE_CREDENTIALS,
    headers: HEADER_JSON
} as RequestInit

export const DEFAULT_DATASOURCE = {
    eventType: '',
    headers: [],
    keys: [],
    perspective: 0,
    skipRealtime: false,
    databaseName: '',
    dateReference: false,
    rules: []
} as Database
